export default __webpack_public_path__ + "static/media/onBoarding-shaded.23293012.png";